import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
export interface IUserOutDepartment {
    keywords: string;
    department_id: string;
    size?: number; // 默认返回100条记录 ，可以指定该数值
}
export interface ISearchUserOutDepartment {
    id: string;
    teacher_id: string;
    student_id: string;
    user_name: string;
    account: string;
    avatar: string;
    email: string;
    phone: string;
    login_name: string;
}
export const searchUserOutDepartment = (data: IUserOutDepartment): Promise<ISearchUserOutDepartment[]> => {
    return fetchData(Api.SEARCH_USER_OUT_DEPARTMENT, data).then((res: IResponse<ISearchUserOutDepartment[]>) => {
        return res.data;
    });
};
